import { useRouteError } from 'react-router-dom';

import { ErrorBoundaryFallback } from '@service-initiation/shared-ui-error-boundary-fallback';

export const ErrorBoundary = () => {
  const error = useRouteError();

  return (
    <ErrorBoundaryFallback
      error={error as Error}
      homePath="*"
      href="/tech-care/repairs"
    />
  );
};
